import {MODAL_TYPE, showModal} from './forecast-app/shared/components/modals/generic_modal_conductor';

function isNetworkError(errorMessage) {
	return (
		errorMessage.includes('Failed to fetch') ||
		errorMessage.includes('TypeError: The Internet connection appears to be offline') ||
		errorMessage.includes('TypeError: NetworkError when attempting to fetch resource') ||
		errorMessage.includes('TypeError: Nätverksanslutningen förlorades') ||
		errorMessage.includes('TypeError: The network connection was lost')
	);
}

function handleResponseBody(body) {
	let errorMessage = '';
	let correlationId = '';
	if (body) {
		if (body.message) {
			errorMessage = body.message;
		}
		if (body.correlationId) {
			correlationId = body.correlationId;
		}
		if (body.status === 404) {
			showModal({
				type: MODAL_TYPE.MUTATION_ERROR_NON_CRITICAL,
				correlationId: correlationId,
				errorType: '404',
			});
		} else {
			showModal({
				type: MODAL_TYPE.MUTATION_ERROR,
				correlationId: correlationId,
				isNetworkError: isNetworkError(errorMessage),
			});
		}
	}
}

export default class DirectApi {
	static FetchJson(requestEndpoint) {
		const headers = new Headers();
		headers.append('Content-Type', 'application/json');

		return this.Fetch(requestEndpoint, {headers: headers, credentials: 'include'});
	}

	static Fetch(requestEndpoint, init) {
		const requestUrl = process.env.GRAPHQL_ENDPOINT.slice(0, -7) + requestEndpoint;
		return new Promise((resolve, reject) => {
			fetch(requestUrl, init)
				.then(response => {
					if (response.ok) {
						resolve(response);
					} else {
						response.json().then(handleResponseBody);
					}
				})
				.catch(err => {
					if (!('' + err).includes('abort')) {
						reject(err);
					}
				});
		});
	}
}
